import { mapActions, mapMutations } from 'vuex'
import { REMOVE_JOB } from 'vx/mutations'
import { noop } from 'lodash'
import { alert } from 'utils'
import $ from 'jquery'

export default {
  methods: {
    ...mapActions('job', ['acceptJob', 'declineJob']),
    ...mapMutations('job', [REMOVE_JOB]),

    /**
     * Handle hiding the modal.
     *
     * @return void
     */
    handleCloseModal () {
      $('.modal-job-request').modal('hide')
    },

    /**
     * Handle approving the request.
     *
     * @return Promise
     */
    handleAcceptRequest () {
      return this.acceptJob(this.job.id)
        .then(this.handleCloseModal)
        .then(this.showAcceptedAlert)
        .then(this.removeJobFromState)
        .then(this.triggerEvents)
    },

    /**
     * Handle declining the request.
     *
     * @return Promise
     */
    handleDeclineRequest () {
      return alert.confirm({
        text: 'This job will be permanently cancelled.',
        showLoaderOnConfirm: true,
        preConfirm: confirmed => {
          if (confirmed) {
            return this.declineJob(this.job.id)
          }

          return Promise.reject()
        }
      })
      .then(this.handleCloseModal)
      .then(this.showDeclinedAlert)
      .then(this.removeJobFromState)
      .then(this.triggerEvents)
      .catch(noop)
    },

    /**
     * Show an alert success message if the job was accepted.
     *
     * @return void
     */
    showAcceptedAlert () {
      alert.success({ text: 'Job request has been accepted.', timer: 2000 })
    },

    /**
     * Show an alert success message if the job was decline.
     *
     * @return void
     */
    showDeclinedAlert () {
      alert.success({ text: 'Job request has been cancelled.', timer: 2000 })
    },

    /**
     * Remove a job from the Vuex state.
     *
     * @return void
     */
    removeJobFromState () {
      this[REMOVE_JOB](this.job)
    },

    /**
     * Trigger events that allow us to hook into the accept/decline actions.
     *
     * @return void
     */
    triggerEvents () {
      this.$bus.$emit('updateNavigation')

      this.$bus.$emit('jobRequestAcceptedOrDeclined', this.job)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/jobs/job-request-actions-helpers.js